import { render, staticRenderFns } from "./OwnPage.vue?vue&type=template&id=749d13b5&scoped=true"
import script from "./OwnPage.vue?vue&type=script&lang=js"
export * from "./OwnPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749d13b5",
  null
  
)

export default component.exports